module.exports = "/dist/roboto-latin-500italic.svg?084d5c434250ba4b6aaa634908eb4b15";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-500italic.svg
// module id = 91
// module chunks = 0